<template>
  <div style="text-align:center" class="qr">
    <div>
      <qrcode-vue :value="url" :size="size" level="H" />
    </div>
    <div class="refresh" v-if="column.remote" @click="handleRefresh">刷新二维码</div>
    <div class="tip">{{tip}}</div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
export default {
  inject: ['viewFormData'],
  props: ['column', 'value'],
  components: {
    QrcodeVue
  },
  data() {
    return {
      url: '',
      logoImg: '',
      tip: '',
      size: 200
    }
  },
  watch: {

  },
  beforeDestroy() {
    this.scrollboadHandle && clearInterval(this.scrollboadHandle)
  },
  mounted() {
    this.initParams()
    this.setRate()
  },
  methods: {
    handleRefresh() {
      const {
        qrurl
      } = this.column
      this.remoteSet(qrurl, this.viewFormData.modelData)
    },
    async remoteSet(qrurl, modelData) {
      const res = await this.$http.post(qrurl,
        modelData
      )
      this.url = res.data.url
      this.logoImg = res.data.logoImg
      this.tip = res.data.tip
      if (res.data.id) {
        this.viewFormData.modelData.id = res.data.id
      }
    },
    setRate() {
      const {
        qrurl,
        rate,
        remote
      } = this.column
      if (remote) {
        this.scrollboadHandle = setInterval(() => {
          this.remoteSet(qrurl, this.viewFormData.modelData)
        }, 1000 * rate)
      }
    },
    initParams() {
      if (this.column.remote) {
        this.remoteSet(this.column.qrurl, this.viewFormData.modelData)
      } else {
        this.url = this.column.url
        this.logoImg = this.column.logoImg
        this.tip = this.column.tip
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.qr {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    padding: 7px;
    div {
      padding: 0px;
    }
    .refresh {
      cursor: pointer;
    }
    .tip {
      color: blue;
      font-size: 15px;
      font-weight:bold;
    }
  }
</style>
